import * as React from "react";

export class SMLogo extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <img src={require('../../images/login_sm_logo.svg')} alt='Soundmouse logo' style={{ height: '170px', width: '240px' }} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Controls/SMLogo.js